import {
    GET_MY_REPORTS,
    DELETE_MY_REPORT,
    SUBMIT_MY_REPORT,
} from '../actions/myreports';
import _ from 'lodash';

const INITIAL_STATE = [];

export default function (state = INITIAL_STATE, action) {
    let index = -1;
    switch (action.type) {
        case GET_MY_REPORTS:
            return [].concat(action.value);
        case DELETE_MY_REPORT:
            index = _.findIndex(state, { '_id':  action.value._id});
            if (index !== -1) {
                state.splice(index, 1);
            }
            return [].concat(state);
        case SUBMIT_MY_REPORT:
            return [].concat(state, [action.value]);

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/myreports.js